/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOrganizationsResponseMeta } from './ListOrganizationsResponseMeta';
import {
    ListOrganizationsResponseMetaFromJSON,
    ListOrganizationsResponseMetaFromJSONTyped,
    ListOrganizationsResponseMetaToJSON,
    ListOrganizationsResponseMetaToJSONTyped,
} from './ListOrganizationsResponseMeta';
import type { Note } from './Note';
import {
    NoteFromJSON,
    NoteFromJSONTyped,
    NoteToJSON,
    NoteToJSONTyped,
} from './Note';

/**
 * Paginated list of notes
 * @export
 * @interface ListNotesResponse
 */
export interface ListNotesResponse {
    /**
     * 
     * @type {Array<Note>}
     * @memberof ListNotesResponse
     */
    notes: Array<Note>;
    /**
     * 
     * @type {ListOrganizationsResponseMeta}
     * @memberof ListNotesResponse
     */
    meta: ListOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ListNotesResponse interface.
 */
export function instanceOfListNotesResponse(value: object): value is ListNotesResponse {
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListNotesResponseFromJSON(json: any): ListNotesResponse {
    return ListNotesResponseFromJSONTyped(json, false);
}

export function ListNotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListNotesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'notes': ((json['notes'] as Array<any>).map(NoteFromJSON)),
        'meta': ListOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ListNotesResponseToJSON(json: any): ListNotesResponse {
    return ListNotesResponseToJSONTyped(json, false);
}

export function ListNotesResponseToJSONTyped(value?: ListNotesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notes': ((value['notes'] as Array<any>).map(NoteToJSON)),
        'meta': ListOrganizationsResponseMetaToJSON(value['meta']),
    };
}

